module.exports = __webpack_public_path__ + "img/ideation-03-explore.0ad100cf.jpg";